<div class="tile">
  <h5 class="mb-4 font-medium">
    {{ 'instrument-detail.instrument-position.headline' | transloco }}
    @if (model?.quantity) {
      @if (model?.quantity % 1 === 0) {
        ({{ model?.quantity | number }} {{ 'instrument-detail.instrument-position.quantity' | transloco }})
      } @else {
        <span class="text-default">
          ({{ model?.quantity | number: '1.0-8' }} {{ 'instrument-detail.instrument-position.qty' | transloco }})
        </span>
      }
    }
  </h5>
  @if (model?.quantity) {
    <div class="d-flex d-lg-block d-xl-flex justify-content-between">
      <div class="text-color-primary">
        {{ 'instrument-detail.instrument-position.rows.avgEntryQuote' | transloco }}
      </div>
      <div class="font-medium text-right">
        @if (model?.avgEntryQuote) {
          {{ model.avgEntryQuote | priceScale: priceScale }}
        } @else {
          <ng-container *ngTemplateOutlet="novalue" />
        }
      </div>
    </div>

    <hr class="less-margin" />
    <div class="d-flex d-lg-block d-xl-flex justify-content-between">
      <div class="text-color-primary">
        {{ 'instrument-detail.instrument-position.rows.currentValue' | transloco }}
      </div>
      <div class="font-medium text-right">
        @if (model?.currentValue) {
          {{ model.currentValue | priceScale: priceScale }}
        } @else {
          <ng-container *ngTemplateOutlet="novalue" />
        }
      </div>
    </div>

    <hr class="less-margin" />
    <div class="d-flex d-lg-block d-xl-flex justify-content-between">
      <div class="text-color-primary">
        {{ 'instrument-detail.instrument-position.rows.avgEntryValue' | transloco }}
      </div>
      <div class="font-medium text-right">
        @if (model?.avgEntryQuote && model?.quantity) {
          {{ model.avgEntryQuote * model?.quantity | priceScale: priceScale }}
        } @else {
          <ng-container *ngTemplateOutlet="novalue" />
        }
      </div>
    </div>

    <hr class="less-margin" />
    <div class="d-flex d-lg-block d-xl-flex justify-content-between">
      <div class="text-color-primary">
        {{ 'instrument-detail.instrument-position.rows.perfPerc' | transloco }}
      </div>
      <div class="font-medium text-right">
        <span [class.text-color-success]="model?.perfAbs >= 0" [class.text-color-error]="model?.perfAbs < 0">
          @if (model?.perfAbs > 0) {
            <span>+</span>{{ model?.perfPct | number: '1.2-2' }}&nbsp;%
          } @else {
            {{ model?.perfPct | number: '1.2-2' }}&nbsp;%
          }
        </span>
      </div>
    </div>

    <hr class="less-margin" />
    <div class="d-flex d-lg-block d-xl-flex justify-content-between">
      <div class="text-color-primary">
        {{ 'instrument-detail.instrument-position.rows.perfAbs' | transloco }}
      </div>
      <div class="font-medium text-right ml-2">
        <span class="text-nowrap" [class.text-color-success]="model?.perfAbs >= 0" [class.text-color-error]="model?.perfAbs < 0">
          @if (model?.perfAbs > 0) {
            <span>+{{ model?.perfAbs | priceScale: priceScale }}</span>
          } @else {
            {{ model?.perfAbs | priceScale: priceScale }}
          }
        </span>
      </div>
    </div>

    @if (model?.dividendAbsolute) {
      <hr class="less-margin" />
      <div class="d-flex d-lg-block d-xl-flex justify-content-between">
        <div class="text-color-primary">
          {{ 'instrument-detail.instrument-position.rows.dividendTotal' | transloco }}
        </div>
        <div class="font-medium text-right ml-2">
          <span
            class="text-nowrap"
            [class.text-color-success]="model?.dividendAbsolute >= 0"
            [class.text-color-error]="model?.dividendAbsolute < 0"
          >
            {{ model?.dividendAbsolute | priceScale: priceScale }}
          </span>
        </div>
      </div>

      <hr class="less-margin" />
      <div class="d-flex d-lg-block d-xl-flex justify-content-between">
        <div class="d-flex justify-content-start">
          <div class="text-color-primary" [innerHTML]="'instrument-detail.instrument-position.rows.dividendYield' | transloco"></div>
          <span class="ml-2" data-zid="info-icon" (click)="modal.open(dividendYieldModalContent, { size: 'lg' })">
            <svg class="icon icon-18 cursor-pointer">
              <use xlink:href="/assets/img/svgs/svgset.svg#info" />
            </svg>
          </span>
        </div>
        <div class="font-medium text-right ml-2">
          @if (model?.dividendYield) {
            <span
              class="text-nowrap"
              [class.text-color-success]="model?.dividendYield >= 0"
              [class.text-color-error]="model?.dividendYield < 0"
            >
              @if (model?.dividendYield > 0) {
                <span>+</span>{{ model?.dividendYield | number: '1.2-2' }}&nbsp;%
              } @else {
                {{ model?.dividendYield | number: '1.2-2' }}&nbsp;%
              }
            </span>
          } @else {
            <ng-container *ngTemplateOutlet="novalue" />
          }
        </div>
      </div>
    }

    <hr class="less-margin" />
    <div class="d-flex d-lg-block d-xl-flex justify-content-between">
      <div class="text-color-primary">
        {{ 'instrument-detail.instrument-position.rows.available' | transloco }}
      </div>
      <div class="font-medium text-right">
        {{ model?.available | number: '1.0-8' }}
      </div>
    </div>
  } @else {
    <hr class="less-margin" />
    <div class="d-flex d-lg-block d-xl-flex justify-content-between">
      <div class="text-color-primary font-bold">
        {{ 'instrument-detail.instrument-position.rows.nonOnHold' | transloco }}
      </div>
    </div>
  }

  @if (hasAssetTimeline) {
    <hr class="less-margin" />
    <div class="d-flex align-items-center">
      <web-design-system-pill type="new">
        {{ 'instrument-detail.instrument-position.newBadge' | transloco | uppercase }}
      </web-design-system-pill>
      <a [routerLink]="instrumentDetailsPage + '/' + isin + '/timeline'" class="link-secondary d-block ml-2">
        {{ 'instrument-detail.instrument-position.timeline' | transloco }}
      </a>
    </div>
  }
</div>
<ng-template #novalue>
  <div class="text-color-primary">&mdash;</div>
</ng-template>

<ng-template #dividendYieldModalContent let-modal>
  <web-design-system-modal
    [headline]="'instrument-detail.instrument-position.modal.dividendYield.headline' | transloco"
    (dismiss)="modal.dismiss('Cross click')"
  >
    <p [innerHTML]="'instrument-detail.instrument-position.modal.dividendYield.text' | transloco"></p>
  </web-design-system-modal>
</ng-template>
